// eslint-disable-next-line import/no-anonymous-default-export
export default {
    bodyPrice: [
        {
        id: 1,
        label: 'Soin du corps',
        time: '20 minutes',
        price: '28'  
        },
        {
        id: 2,
        label: '',
        time: '30 minutes',
        price: '35'  
        },
        {
        id: 3,
        label: '',
        time: '50 minutes',
        price: '58'  
        },
        {
        id: 4,
        label: '',
        time: '70 minutes',
        price: '70'  
        },
        {
        id: 5,
        label: 'Gommage',
        time: '30 minutes',
        price: '20'  
        },
        {
        id: 6,
        label: 'Enveloppement',
        time: '20 minutes',
        price: '20'  
        },
        {
        id: 7,
        label: 'Soin visage',
        time: '1 heure',
        price: '45'  
        },
        {
        id: 8,
        label: 'Manucure',
        time: '',
        price: '30'  
        },
        {
        id: 9,
        label: 'Beauté des pieds',
        time: '',
        price: '42'  
        }
    ],

    skinPrice: [
        {
        id: 1,
        label: 'Prendre son temps',
        time: '45 minutes',
        price: '39'  
        },
        {
        id: 2,
        label: '',
        time: '50 minutes',
        price: '43'  
        },
        {
        id: 3,
        label: '',
        time: '60 minutes',
        price: '48'  
        },
        {
        id: 4,
        label: '',
        time: '70 minutes',
        price: '53'  
        },
        {
        id: 5,
        label: '',
        time: '80 minutes',
        price: '59'  
        },
        {
        id: 6,
        label: 'Le soin de saison',
        price: '59€ ➜ 69'  
        },
        {
        id: 7,
        label: 'Modelage du dos',
        tome: '20 minutes',
        price: '+20'  
        },
        {
        id: 8,
        label: 'Modelage cuir chevelu ou mains',
        time: '',
        price: '+10'  
        },
        {
        id: 9,
        label: 'Byebye points noirs',
        time: '',
        price: '+5'  
        },
        {
        id: 10,
        label: 'Anti-âge',
        time: '',
        price: '+5'  
        },
        {
        id: 11,
        label: 'Maquillage jour',
        time: '',
        price: '20'  
        },
        {
        id: 12,
        label: 'Maquillage soir',
        time: '',
        price: '26'  
        },
        {
        id: 13,
        label: 'Maquillage mariée',
        time: '',
        price: '45'  
        },
        {
        id: 14,
        label: 'Maquillage cours',
        time: '',
        price: '40'  
        },
    ],
    epilWo:[
        {
         id: 1,
         label: 'Teinture sourcils',
         price: '12'  
        },
        {
        id: 2,
        label: 'Sourcils',
        price: '8.50'  
        },
        {
        id: 3,
        label: 'Teinture cils',
        price: '17'  
        },
        {
        id: 4,
        label: 'Lèvres',
        price: '6'  
        },
        {
        id: 5,
        label: 'Visage',
        price: '16'  
        },
        {
        id: 6,
        label: 'Menton',
        price: '6'  
        },
        {
        id: 7,
        label: 'Aisselles',
        price: '9'  
        },
        {
        id: 8,
        label: 'Bras',
        price: '15'  
        },
        {
        id: 9,
        label: 'Maillot simple',
        price: '10'  
        },
        {
        id: 10,
        label: 'Maillot échancré',
        price: '17'  
        },
        {
        id: 11,
        label: 'Maillot intégral',
        price: '26'  
        },
        {
        id: 12,
        label: 'Cuisses',
        price: '19'  
        },
        {
        id: 13,
        label: 'Jambes complètes',
        price: '26'  
        },
        {
        id: 14,
        label: '1/2 jambes',
        price: '17'  
        }
    ],
    epilMen: [
        {
         id: 1,
         label: 'Sourcils',
         price: '10'  
        },
        {
        id: 2,
        label: 'Nez',
        price: '5'  
        },
        {
        id: 3,
        label: 'Oreilles',
        price: '5'  
        },
        {
        id: 4,
        label: 'Epaules',
        price: '10'  
        },
        {
        id: 5,
        label: 'Torse',
        price: '20'  
        },
        {
        id: 6,
        label: 'Aiselles',
        price: '10'  
        },
        {
        id: 7,
        label: 'Dos',
        price: '20'  
        },
        {
        id: 8,
        label: 'Jambes',
        price: '30'  
        }
    ]
}